const TOS_MYSCP_EULA_ID = 153888710
const TOS_TELEHEALTH_ID = 108451128
const TOS_TELEHEALTH_PRIVACY_POLICY_ID = 108674791

export {
  TOS_MYSCP_EULA_ID,
  TOS_TELEHEALTH_ID,
  TOS_TELEHEALTH_PRIVACY_POLICY_ID
}
